import styled from 'styled-components';
import { COLORS, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

interface WrapperProps {
  isActive?: boolean;
  isCaMarket?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  background-color: ${COLORS.white};
  display: inline-flex;
  padding: 24px 16px 28px 16px;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: inset 0 0 0 1px ${COLORS.grey10};
  margin: 0;
  margin-top: -2px;
  justify-content: space-between;
  gap: 10px;
  flex-grow: 1;
  @media ${device.laptop} {
    padding: 20px 20px;
    border-top: ${({ isCaMarket }) => !isCaMarket && `1px solid ${COLORS.grey15}`};
    border-bottom: ${({ isCaMarket }) => !isCaMarket && `1px solid ${COLORS.grey15}`};
    border-left: ${({ isCaMarket }) => !isCaMarket && `1px solid ${COLORS.grey15}`};
    width: 366px;
    flex-grow: initial;
    box-shadow: unset;
    margin-top: unset;
  }
`;

export const VehicleNameWrapper = styled.div`
  padding-bottom: 12px;
  max-height: 48px;
`;

export const Title = styled.h3`
  margin: 0;
  color: ${COLORS.grey80};
  font-family: 'Audi Type';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.002px;
`;

export const TagWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${SIZING.unit(0.5)};
`;

export const TitleWrapper = styled.div`
  margin-bottom: 4px;
`;

export const TrimLineWrapper = styled.div`
  margin-bottom: 4px;
`;

export const DescriptionWrapper = styled.div`
  margin-bottom: 8px;
  max-height: 126px;
  overflow-y: auto;
`;

export const ViewOfferCTA = styled.button`
  padding: 0;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  color: ${COLORS.grey60};
  font-family: 'Audi Type';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.002px;
  cursor: pointer;
`;

export const CreditCTA = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  background-color: transparent;
`;

export const InfoContainer = styled.div`
  width: 100%;
`;

export const CreditCtaLabel = styled.div<{
  color?: string;
  size?: 'small' | 'medium';
  isBold?: boolean;
}>`
  cursor: pointer;
  font-family: 'Audi Type';
  border: none;
  background-color: transparent;
  font-size: ${({ size }) => (size === 'medium' ? '16px' : '12px')};
  line-height: ${({ size }) => (size === 'medium' ? '24px' : '20px')};
  color: ${(props) => (props.color ? props.color : COLORS.black)};
  border-bottom: 1px solid ${(props) => (props.color ? props.color : COLORS.black)};
  padding: 0;
  font-weight: ${({ isBold }) => (isBold ? '700' : '400')};
  padding-bottom: 2px;
`;
